import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance/axiosInstance";
import { SyncJobRun } from "./SyncJobRun";

export const fetchSyncJobRuns = createAsyncThunk(
  "syncJobs/fetchSyncJobRuns",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<SyncJobRun[]>("/syncjobrun");
      return response.data;
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue("An unknown error occurred");
    }
  }
);
